import React from 'react';
import PropTypes from 'prop-types';
import { invoiceReceiptDateTime } from 'utils/formatter';
import moment from 'moment';
import styles from './InfoBox.css';

class ReceiptInfo extends React.Component {
  render() {
    const { invoiceDetail } = this.props;
    return (
      <div className={styles['receipt-info-box']}>
        <div className={styles['receipt-date']}>
          <div className="pull-left">
            {invoiceReceiptDateTime(invoiceDetail.created_at, 'date')}
          </div>
          <div className="pull-right">
            {invoiceReceiptDateTime(invoiceDetail.created_at, 'time')}
          </div>
        </div>

        <div className={styles['receipt-number']}>
          <div className="pull-left">Invoice Number</div>
          <div className="pull-right">{invoiceDetail.invoice_no}</div>
        </div>

        {invoiceDetail.table_name && (
          <div className={styles['receipt-number']}>
            <div className="pull-left">Table Name</div>
            <div className="pull-right">{invoiceDetail.table_name}</div>
          </div>
        )}

        {invoiceDetail.served_by && (
          <div className={styles['receipt-served']}>
            <div className="pull-left">Served By</div>
            <div className="pull-right">{invoiceDetail.served_by}</div>
          </div>
        )}

        <div className={styles['receipt-collected']}>
          <div className="pull-left">Collected By</div>
          <div className="pull-right">{invoiceDetail.collected_by}</div>
        </div>

        {(invoiceDetail.customer_name || invoiceDetail.customer_email) && (
          <div className={styles['receipt-served']}>
            <div className="pull-left">Customer</div>
            <div className="pull-right">
              {invoiceDetail.customer_name || invoiceDetail.customer_email}
            </div>
          </div>
        )}

        <div
          className={
            invoiceDetail.invoice_status !== 'paid'
              ? styles['payment-due-invoice']
              : styles['payment-due-invoice-black']
          }
        >
          Payment Due by{' '}
          {moment(invoiceDetail.invoice_due_date).format('DD MMM YYYY')}
        </div>
      </div>
    );
  }
}

ReceiptInfo.propTypes = {
  invoiceDetail: PropTypes.object,
};

export default ReceiptInfo;
